var map = {
	"./black/xiazailuyin.png": "/uYZ",
	"./blue/xiazailuyin.png": "uO1G",
	"./white/xiazailuyin.png": "ulki"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "R04B";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazailuyin\.png$
// module id = R04B
// module chunks = 24